import React from 'react';
import { getPageDisplayStatus } from '../datatypes/tabsconstants'
import { Outlet } from 'react-router-dom';
import { DetailPageContainer, DataTableWrapper, PageHeader, DataTable } from '../components/Common';
import '../components/Common/DataTable.css';
import { isMobile } from "react-device-detect";
import AGGridDataTableEngine from "../components/Common/DataTableEngine/AGGridDataTableEngine";
import { useDataTableContext } from '../components/Common/DataTableEngine/shared/Context';
import { generateColumnAndViewFields, getDefaultFilterParams } from '../components/Common/DataTableEngine/shared/shared';
import { mapToAGGridColumns } from '../components/Common/DataTableEngine/AGGridDataTableEngineWrapper';
import { useLocation } from 'react-router-dom';

const PageContent = ( props ) => {
    const {id, tabname, actions,  breadCrumbArr,serviceProgress,pageButtons,countLabel, dataTableOption, name, dataTableView, refresh, exportInit,isRowDeleted,rowHeight , agGridTableHeight, childUrl, stepperIndex } = props;
    let { COLUMN_FIELDS_PROPS, VIEW_FIELDS_PROPS } = props;
    const { VIEW_FIELDS_REF, COLUMN_FIELDS_REF } = useDataTableContext();
    const tableHeight = (typeof agGridTableHeight === 'string' && agGridTableHeight.includes('%')) ? agGridTableHeight : '100%';
    
    let display = getPageDisplayStatus(id, tabname);

    let opts = {};
    opts['display'] = display;
    if(props.wrapperClass) {
        opts['wrapperClass'] = props.wrapperClass;
    }
    
    const location = useLocation();
    const isChildView = location.pathname.includes(childUrl);
    const urlSearch = location.search;
    const { selectedDevices, selectedFirmware } = location.state || {};    
    let agGridColumns, fetchUrl;
    const { VIEW_FIELDS_DEFAULT , COLUMN_FIELDS_DEFAULT } = generateColumnAndViewFields(dataTableOption);
    if(!VIEW_FIELDS_PROPS) {
      VIEW_FIELDS_PROPS = VIEW_FIELDS_DEFAULT;
    }
    if(!COLUMN_FIELDS_PROPS) {
      COLUMN_FIELDS_PROPS = COLUMN_FIELDS_DEFAULT;
    }

    // const defaultFilterQueryObj = getDefaultFilterQueryObj(dataTableOption);
    // const browserWidth = window.innerWidth;
    // console.log('browserWidth', browserWidth);
    // const resizedColumns = adjustColumnWidths(agGridColumns,dataTableOption?.agGridAdjustWidthKeys, browserWidth);

    if(!isChildView){
        const hasRowHeightOption = pageButtons.some(pb => pb.type === "row_height");
	      dataTableOption.hasRowHeightOption = hasRowHeightOption ?? false;
        agGridColumns = mapToAGGridColumns<any>(dataTableOption, name, VIEW_FIELDS_PROPS, urlSearch);
        fetchUrl = dataTableOption?.url.replace('/uiapi', '');
    }
    const defaultFilterQueryParams = getDefaultFilterParams(dataTableOption, urlSearch);

    VIEW_FIELDS_REF.current = VIEW_FIELDS_PROPS;
    COLUMN_FIELDS_REF.current = COLUMN_FIELDS_PROPS;

    return (
      <>
        <DataTableWrapper {...opts}>
        <PageHeader
                name={name}
                breadCrumbArr={breadCrumbArr}
                serviceProgress={serviceProgress}
                columns={dataTableOption.columns}
                pageButtons={pageButtons}
                countLabel={countLabel}
                dataTableView={dataTableView}
                SELECTALL_BULKACTION_LIMIT={100}
              />
          {!isChildView && (
          isMobile ? (
                <DataTable name={name} display={display}  dataTableOption={dataTableOption} refresh={refresh} exportInit={exportInit} countLabel={countLabel}  isRowDeleted={isRowDeleted} rowHeight={rowHeight} dataTableView={dataTableView} /> 
              )
              :
            <div style={{
              height: tableHeight,
              display: 'flex',
              flexDirection: 'column',
              fontSize: '12px',
            }}>
              <AGGridDataTableEngine
                key={name ?? ''}
                columns={agGridColumns}
                fetchUrl={fetchUrl}
                pagination={true}
                dataTableOption={dataTableOption}
                refresh={refresh}
                exportInit={exportInit}
                name={name}
                selectedDevices={selectedDevices}
                defaultFilterQueryParams={defaultFilterQueryParams}
                selectedFirmware={selectedFirmware}
                activeStep = {stepperIndex}
              />
            </div>
            )}
        </DataTableWrapper>
        <div>
          <DetailPageContainer>
            <Outlet context={{ actions: actions }} />
          </DetailPageContainer>
        </div>
        {props.children}
      </>
    );
}

export default PageContent;